export function useIsInternalReviewer(): boolean {
  try {
    const raw = sessionStorage.getItem("TARS_IS_INTERNAL");
    return raw ? JSON.parse(raw) === true : false;
  } catch {
    return false;
  }
}
